export default {
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.forgotPassword': 'Forgot Password',
    'menu.changePassword': 'Change Password',
    'menu.apply': 'My Applications',
    'menu.logout': 'Logout',
    'menu.settings': 'Settings',
    'menu.settings.profile': 'Profile',
    'menu.settings.appearance': 'Appearance',
    'menu.settings.notifications': 'Notifications',
    'menu.settings.access': 'Access',
    'menu.settings.access.emails': 'Emails',
    'menu.settings.access.security': 'Password and authentication',
    'menu.admin': 'Admin',
    'menu.admin.applications': 'Applications',
};
